import React, { useEffect, useState } from "react";
import Header from "./Header";
import ConfirmModal from "./ConfirmModal";
import useGetSessions from "./Endpoints/GetSessions";
import { useNavigate } from "react-router-dom";
import useDeleteSession from "./Endpoints/DeleteSession";

function ViewPreviousEvaluation() {
  const [sessions, setSessions] = useState([]);
  const [filteredSessions, setFilteredSessions] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setModalOpen] = useState(false);
  const [currentSessionId, setCurrentSessionId] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage] = useState(30);
  const navigate = useNavigate();
  const getSessions = useGetSessions();
  const deleteSession = useDeleteSession();

  useEffect(() => {
    getSessions((data) => {
      setSessions(data);
      setFilteredSessions(data);
    });
  }, []);

  useEffect(() => {
    const filtered = sessions.filter((session) =>
      session.session_name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setFilteredSessions(filtered);
  }, [searchQuery, sessions]);

  const handleClickSession = (sessionId) => {
    navigate("/view_evaluation", { state: { sessionId } });
  };

  const handleDelete = (session_id) => {
    setCurrentSessionId(session_id);
    setModalOpen(true);
  };

  const confirmDelete = () => {
    deleteSession(currentSessionId);
    setModalOpen(false);
  };

  const indexOfLastSession = currentPage * rowsPerPage;
  const indexOfFirstSession = indexOfLastSession - rowsPerPage;
  const currentSessions = filteredSessions.slice(
    indexOfFirstSession,
    indexOfLastSession
  );
  const totalPages = Math.ceil(filteredSessions.length / rowsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);
  const nextPage = () =>
    setCurrentPage((prev) => (prev < totalPages ? prev + 1 : prev));
  const prevPage = () => setCurrentPage((prev) => (prev > 1 ? prev - 1 : prev));

  return (
    <>
      <Header />
      <div className="container mx-auto p-4">
        <p onClick={() => navigate("/")} className="  cursor-pointer">
          <svg
            width="100"
            height="42"
            viewBox="0 0 100 42"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect x="1" y="1" width="98" height="40" rx="8" stroke="#1D4ED8" />
            <path
              d="M23.75 25.5L19.25 21L23.75 16.5L24.8 17.55L22.1 20.25H32.75V21.75H22.1L24.8 24.45L23.75 25.5Z"
              fill="#1D4ED8"
            />
            <path
              d="M48.0902 21.502H45.5541L45.5404 20.251H47.7553C48.129 20.251 48.4457 20.1963 48.7055 20.0869C48.9698 19.973 49.1703 19.8112 49.307 19.6016C49.4438 19.3874 49.5121 19.1299 49.5121 18.8291C49.5121 18.4964 49.4483 18.2253 49.3207 18.0156C49.1931 17.806 48.9971 17.6533 48.7328 17.5576C48.473 17.4619 48.1404 17.4141 47.7348 17.4141H46.0736V26H44.3578V16.0469H47.7348C48.2816 16.0469 48.7693 16.0993 49.1977 16.2041C49.6306 16.3089 49.9975 16.473 50.2982 16.6963C50.6036 16.915 50.8337 17.193 50.9887 17.5303C51.1482 17.8675 51.2279 18.2686 51.2279 18.7334C51.2279 19.1436 51.1299 19.5195 50.934 19.8613C50.738 20.1986 50.4486 20.4743 50.0658 20.6885C49.683 20.9027 49.2068 21.0303 48.6371 21.0713L48.0902 21.502ZM48.015 26H45.0141L45.7865 24.6396H48.015C48.4024 24.6396 48.726 24.5758 48.9857 24.4482C49.2455 24.3161 49.4392 24.1361 49.5668 23.9082C49.699 23.6758 49.765 23.4046 49.765 23.0947C49.765 22.7712 49.7081 22.4909 49.5941 22.2539C49.4802 22.0124 49.3002 21.8278 49.0541 21.7002C48.808 21.568 48.4867 21.502 48.0902 21.502H46.1625L46.1762 20.251H48.685L49.0746 20.7227C49.6215 20.7409 50.0704 20.8617 50.4213 21.085C50.7768 21.3083 51.0411 21.5977 51.2143 21.9531C51.3874 22.3086 51.474 22.6914 51.474 23.1016C51.474 23.735 51.335 24.266 51.057 24.6943C50.7836 25.1227 50.3894 25.4486 49.8744 25.6719C49.3594 25.8906 48.7396 26 48.015 26ZM57.3094 24.5166V20.9893C57.3094 20.7249 57.2615 20.4971 57.1658 20.3057C57.0701 20.1143 56.9243 19.9661 56.7283 19.8613C56.5369 19.7565 56.2954 19.7041 56.0037 19.7041C55.7348 19.7041 55.5024 19.7497 55.3064 19.8408C55.1105 19.932 54.9578 20.055 54.8484 20.21C54.7391 20.3649 54.6844 20.5404 54.6844 20.7363H53.0438C53.0438 20.4447 53.1144 20.1621 53.2557 19.8887C53.3969 19.6152 53.602 19.3714 53.8709 19.1572C54.1398 18.943 54.4611 18.7744 54.8348 18.6514C55.2085 18.5283 55.6277 18.4668 56.0926 18.4668C56.6486 18.4668 57.1408 18.5602 57.5691 18.7471C58.0021 18.9339 58.3416 19.2165 58.5877 19.5947C58.8383 19.9684 58.9637 20.4378 58.9637 21.0029V24.291C58.9637 24.6283 58.9865 24.9313 59.032 25.2002C59.0822 25.4645 59.1528 25.6947 59.2439 25.8906V26H57.5555C57.478 25.8223 57.4165 25.5967 57.3709 25.3232C57.3299 25.0452 57.3094 24.7764 57.3094 24.5166ZM57.5486 21.502L57.5623 22.5205H56.3797C56.0743 22.5205 55.8055 22.5501 55.573 22.6094C55.3406 22.6641 55.1469 22.7461 54.992 22.8555C54.837 22.9648 54.7208 23.097 54.6434 23.252C54.5659 23.4069 54.5271 23.5824 54.5271 23.7783C54.5271 23.9743 54.5727 24.1543 54.6639 24.3184C54.755 24.4779 54.8872 24.6032 55.0604 24.6943C55.2381 24.7855 55.4523 24.8311 55.7029 24.8311C56.0402 24.8311 56.3341 24.7627 56.5848 24.626C56.84 24.4847 57.0405 24.3138 57.1863 24.1133C57.3322 23.9082 57.4096 23.7145 57.4188 23.5322L57.952 24.2637C57.8973 24.4505 57.8038 24.651 57.6717 24.8652C57.5395 25.0794 57.3663 25.2845 57.1521 25.4805C56.9425 25.6719 56.6896 25.8291 56.3934 25.9521C56.1017 26.0752 55.7645 26.1367 55.3816 26.1367C54.8986 26.1367 54.4679 26.041 54.0896 25.8496C53.7114 25.6536 53.4152 25.3916 53.201 25.0635C52.9868 24.7308 52.8797 24.3548 52.8797 23.9355C52.8797 23.5436 52.9526 23.1973 53.0984 22.8965C53.2488 22.5911 53.4676 22.3359 53.7547 22.1309C54.0464 21.9258 54.4018 21.7708 54.8211 21.666C55.2404 21.5566 55.7189 21.502 56.2566 21.502H57.5486ZM63.8078 24.8242C64.0767 24.8242 64.3182 24.7718 64.5324 24.667C64.7512 24.5576 64.9266 24.4072 65.0588 24.2158C65.1955 24.0244 65.2707 23.8034 65.2844 23.5527H66.8361C66.827 24.0312 66.6857 24.4665 66.4123 24.8584C66.1389 25.2503 65.7766 25.5625 65.3254 25.7949C64.8742 26.0228 64.3752 26.1367 63.8283 26.1367C63.2632 26.1367 62.771 26.041 62.3518 25.8496C61.9325 25.6536 61.5839 25.3848 61.3059 25.043C61.0279 24.7012 60.8182 24.307 60.677 23.8604C60.5402 23.4137 60.4719 22.9352 60.4719 22.4248V22.1855C60.4719 21.6751 60.5402 21.1966 60.677 20.75C60.8182 20.2988 61.0279 19.9023 61.3059 19.5605C61.5839 19.2188 61.9325 18.9521 62.3518 18.7607C62.771 18.5648 63.2609 18.4668 63.8215 18.4668C64.4139 18.4668 64.9335 18.5853 65.3801 18.8223C65.8267 19.0547 66.1776 19.3805 66.4328 19.7998C66.6926 20.2145 66.827 20.6976 66.8361 21.249H65.2844C65.2707 20.9756 65.2023 20.7295 65.0793 20.5107C64.9608 20.2874 64.7922 20.1097 64.5734 19.9775C64.3592 19.8454 64.1018 19.7793 63.801 19.7793C63.4683 19.7793 63.1926 19.8477 62.9738 19.9844C62.7551 20.1165 62.5842 20.2988 62.4611 20.5312C62.3381 20.7591 62.2492 21.0166 62.1945 21.3037C62.1444 21.5863 62.1193 21.8802 62.1193 22.1855V22.4248C62.1193 22.7301 62.1444 23.0264 62.1945 23.3135C62.2447 23.6006 62.3313 23.8581 62.4543 24.0859C62.5819 24.3092 62.7551 24.4893 62.9738 24.626C63.1926 24.7581 63.4706 24.8242 63.8078 24.8242ZM69.8619 15.5V26H68.2076V15.5H69.8619ZM74.4557 18.6035L71.2359 22.1719L69.4723 23.9766L69.0416 22.582L70.3746 20.9346L72.4664 18.6035H74.4557ZM72.8219 26L70.4225 22.5273L71.4615 21.3721L74.7291 26H72.8219Z"
              fill="#1D4ED8"
            />
          </svg>
        </p>
        <div className="search-container mb-4 relative w-[20%] float-right">
          <input
            type="text"
            placeholder="Search by session name"
            className="px-4 py-2 w-full border rounded shadow "
            onChange={(e) => {
              setSearchQuery(e.target.value);
            }}
          />
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="absolute top-1/2 right-3 transform -translate-y-1/2"
            width="20"
            height="20"
            viewBox="0 0 26 26"
            style={{ fill: "currentColor" }}
          >
            <path d="M 10 0.1875 C 4.578125 0.1875 0.1875 4.578125 0.1875 10 C 0.1875 15.421875 4.578125 19.8125 10 19.8125 C 12.289063 19.8125 14.394531 19.003906 16.0625 17.6875 L 16.9375 18.5625 C 16.570313 19.253906 16.699219 20.136719 17.28125 20.71875 L 21.875 25.34375 C 22.589844 26.058594 23.753906 26.058594 24.46875 25.34375 L 25.34375 24.46875 C 26.058594 23.753906 26.058594 22.589844 25.34375 21.875 L 20.71875 17.28125 C 20.132813 16.695313 19.253906 16.59375 18.5625 16.96875 L 17.6875 16.09375 C 19.011719 14.421875 19.8125 12.300781 19.8125 10 C 19.8125 4.578125 15.421875 0.1875 10 0.1875 Z M 10 2 C 14.417969 2 18 5.582031 18 10 C 18 14.417969 14.417969 18 10 18 C 5.582031 18 2 14.417969 2 10 C 2 5.582031 5.582031 2 10 2 Z M 4.9375 7.46875 C 4.421875 8.304688 4.125 9.289063 4.125 10.34375 C 4.125 13.371094 6.566406 15.8125 9.59375 15.8125 C 10.761719 15.8125 11.859375 15.433594 12.75 14.8125 C 12.511719 14.839844 12.246094 14.84375 12 14.84375 C 8.085938 14.84375 4.9375 11.695313 4.9375 7.78125 C 4.9375 7.675781 4.933594 7.574219 4.9375 7.46875 Z"></path>
          </svg>
        </div>

        <table className="w-full text-left border-collapse shadow-lg">
          <thead>
            <tr className="bg-[#2a3b5d] rounded-t-lg">
              <th className="border-b border-gray-300 p-4 text-sm font-semibold text-gray-100">
                S.No
              </th>
              <th className="border-b border-gray-300 p-4 text-sm font-semibold text-gray-100">
                Session Name
              </th>
              <th className="border-b border-gray-300 p-4 text-sm font-semibold text-gray-100">
                Created Timestamp
              </th>
              <th className="border-b border-gray-300 p-4 text-sm font-semibold text-gray-100">
                Action
              </th>
            </tr>
          </thead>
          <tbody>
            {currentSessions.map((item, index) => (
              <tr key={item.id} className="hover:bg-gray-100">
                <td className="border-b border-gray-300 p-4 text-sm text-gray-600">
                  {index + 1 + (currentPage - 1) * rowsPerPage}
                </td>
                <td
                  className="border-b border-gray-300 p-4 text-sm text-gray-600 cursor-pointer"
                  onClick={() => handleClickSession(item.session_id)}
                >
                  {item.session_name}
                </td>
                <td className="border-b border-gray-300 p-4 text-sm text-gray-600">
                  {item.created_timestamp}
                </td>
                <td className="border-b border-gray-300 p-4 text-sm">
                  <button
                    onClick={() => handleDelete(item.session_id)}
                    className="text-white bg-red-500 hover:bg-red-600 focus:outline-none focus:ring-4 focus:ring-red-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center transition duration-150 ease-in-out"
                  >
                    Delete
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
          <tfoot>
            <tr className="bg-[#2a3b5d]">
              <td colSpan="4" className="p-2 text-center">
                <button
                  onClick={prevPage}
                  className="mr-2 px-4 py-2 bg-[white] text-[black] rounded hover:bg-[#b2ebf2] disabled:opacity-10"
                  disabled={currentPage === 1}
                >
                  {"<"}
                </button>
                <span className="text-white">
                  Page {currentPage} of {totalPages}
                </span>
                <button
                  onClick={nextPage}
                  className="ml-2 px-4 py-2 bg-[white] text-[black] rounded hover:bg-[#b2ebf2] disabled:opacity-10"
                  disabled={currentPage === totalPages}
                >
                  {">"}
                </button>
              </td>
            </tr>
          </tfoot>
        </table>
      </div>
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={() => setModalOpen(false)}
        onConfirm={confirmDelete}
        message="Are you sure you want to delete this session?"
      />
    </>
  );
}

export default ViewPreviousEvaluation;
